import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CategoryEnum, UserDetails } from '@classifieds-sell/datalayer';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { filter } from 'rxjs/operators';
import { removeTrailingSlash } from '@classifieds-sell/shared';
import { IRouterData, RouterFacade, UserFacade } from '@classifieds-sell/state';

@Injectable()
export class AnalyticsService {
    private _userDetails: UserDetails;
    private _routerData: IRouterData;

    constructor(
        @Inject(APP_BASE_HREF) public baseHref: string,
        private _router: Router,
        private _userFacade: UserFacade,
        private _routerFacade: RouterFacade,
        private _gtmService: GoogleTagManagerService
    ) {}

    init() {
        this._userFacade.userDetails$.subscribe((ud) => {
            this._userDetails = ud;
        });

        this._routerFacade.routerData$.subscribe((rd) => {
            this._routerData = rd;
        });

        this._router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe({
                next: (e) => {
                    const event = e as NavigationEnd;
                    const gtmTag = {
                        event: 'pageView',
                        userId:
                            !this._userDetails ||
                            !this._userDetails.memberSummary ||
                            !this._userDetails.memberSummary
                                .externalTrackingToken
                                ? ''
                                : this._userDetails.memberSummary
                                      .externalTrackingToken,
                        businessLine: 'property',
                        categoryLevel1: 'trade-me-property',
                        categoryLevel2: this.getCategoryLevel2Value(
                            this._routerData.categoryId
                        ),
                        categoryLevel3: this.getCategoryLevel3Value(
                            this._routerData.categoryId
                        ),
                        url: `${removeTrailingSlash(this.baseHref)}${event.url}`
                    };

                    this._gtmService.pushTag(gtmTag);
                }
            });
    }

    private getCategoryLevel2Value(c: CategoryEnum): string {
        switch (c) {
            case CategoryEnum.residentialForRent:
            case CategoryEnum.residentialForSale:
                return 'residential';
            case CategoryEnum.newHomesHouseAndLand:
            case CategoryEnum.newHomesNewApartment:
            case CategoryEnum.newHomesNewHouse:
            case CategoryEnum.newHomesNewTownhouseAndTerraced:
                return 'new-homes';
            default:
                return '';
        }
    }

    private getCategoryLevel3Value(c: CategoryEnum): string {
        switch (c) {
            case CategoryEnum.residentialForRent:
                return 'for-rent';
            case CategoryEnum.residentialForSale:
                return 'for-sale';
            case CategoryEnum.newHomesHouseAndLand:
                return 'house-and-land';
            case CategoryEnum.newHomesNewApartment:
                return 'new-apartment';
            case CategoryEnum.newHomesNewHouse:
                return 'new-house';
            case CategoryEnum.newHomesNewTownhouseAndTerraced:
                return 'new-townhouse-and-terraced';
            default:
                return '';
        }
    }
}
